<template>
    <v-card 
        :class="`mt-3 file-exhibition-card ${!mobile ? 'mr-4' : ''}`"
    >
        <v-card-title 
            :style="{ color: themeColor }"
            primary-title
        >
            <v-layout justify-space-between row>
                <div class="file-exhibition-card__title">
                    {{ title }}
                </div>
                <div class="file-exhibition-info">
                    <div class="file-exhibition-card__date">
                        {{ formatDate(date) }}
                    </div>
                    <div class="file-exhibition-card__status file-exhibition-card__status__visualized" v-if="visualized">
                        <i :class="`bexsicon-msg-sent`" /> Lido
                    </div>
                    <div class="file-exhibition-card__status" v-else>
                        <i :class="`bexsicon-close`" /> Não Lido
                    </div>
                </div>
            </v-layout>
        </v-card-title>
        <v-card-text>
            {{ description }}
        </v-card-text>
        <v-card-actions>
            <v-btn
                :style="{ color: themeColor }"
                @click="$emit('previewFile')"
            >
                <i :class="`bexsicon-${buttonIcon} file-exhibition-card__icon`" /> 
                {{ buttonText }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name:'file-exhibition-card',
    props: {
        title: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        buttonIcon: {
            type: String,
            required: true
        },
        themeColor: {
            type: String,
            required: true
        },
        description: String,
        visualized: Boolean,
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
    .file-exhibition-card {
        &__date {
            font-size: 12px;
            text-align: center;
            color: var(--label-color);
        }

        &__title {
            word-break: break-all;
            font-size: 21px;
        }
        &__info {
            // flex: .1;
            width: 70px;
        }

        &__icon {
            padding: 0 5px;
        }

        &:last-of-type {
            margin-bottom: 30px;
        }
        
        &__status {
            width: 90px;
            font-size: 0.7em;
            margin-left: auto;
            text-align: center;
            right: 1em;
            background-color: var(--light-dark-color);
            color: #f5f5f5;
            padding: 0.15em 0.5em;
            border-radius: 25px;
            @include breakpoint(mobile) {
                padding: 0.15em 0.3em;
                width: 70px;
            }

            &__visualized {
                background-color: #f5f5f5;
                color: var(--light-dark-color);
            }

            i {
                padding: 0 .1em;
                font-size: .8em;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/FileExhibitionCard.vue